<template>
    <div class="popular-brands-slider md:bg-grayBg md:px-8 md:py-8 rounded-3xl">
        <h2 class="text-2xl font-semibold mb-6">
            Популярные бренды
        </h2>
        <div class="relative">
            <button @click.prevent="slidePrev" aria-label="Назад"
                    class="max-md:hidden absolute top-[70px] -left-5 z-10 bg-baseColor md:hover:bg-baseColor/70 text-white rounded-full w-10 h-10 flex items-center justify-center transition backdrop-blur">
                <IconAngleLeft class="w-5 h-5 text-black"/>
            </button>
            <Swiper :modules="modules"
                    :slides-per-view="4"
                    :space-between="20"
                    :breakpoints="breakpoints"
                    :loop="brands.length > maxSlidesPerView"
                    :pagination="{ clickable: true }"
                    :autoplay="{ delay: 5000, disableOnInteraction: false }"
                    @swiper="setSwiper"
                    class="pagination-base long_bullet">
                <SwiperSlide v-for="brand in brands" :key="brand.id" class="sm:mb-16">
                    <Link :href="route('catalog', {category_title:'plitka', brands: JSON.stringify([brand.id])})"
                          class="flex flex-col items-center justify-center bg-white px-3 md:px-6 py-6 rounded-lg shadow md:hover:shadow-lg transition overflow-hidden border-2 md:border-0">
                        <img :src="`/assets/brands/${brand.image}`"
                             :alt="'Бренд'+brand.title" :title="'Бренд'+brand.title"
                             class="h-24 w-auto object-contain mb-4"/>
                        <div class="max-w-[95%] text-sm font-medium text-gray-700 text-nowrap truncate">
                            {{ brand.title }}
                        </div>
                    </Link>
                </SwiperSlide>
            </Swiper>
            <button @click.prevent="slideNext" aria-label="Вперед"
                    class="max-md:hidden absolute top-[70px] -right-5 z-10 bg-baseColor md:hover:bg-baseColor/70 text-white rounded-full w-10 h-10 flex items-center justify-center transition backdrop-blur">
                <IconAngleLeft class="w-5 h-5 text-black rotate-180"/>
            </button>
        </div>
    </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'swiper/vue'
import {Navigation, Pagination, Autoplay} from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import {Link} from '@inertiajs/vue3'
import axios from 'axios'
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";

export default {
    name: 'PopularBrandSlider',
    components: {IconAngleLeft, Swiper, SwiperSlide, Link},
    data() {
        return {
            brands: [],
            is_loading: false,
            swiper: null,
            // адаптивные настройки по ширине экрана
            breakpoints: {
                320: {slidesPerView: 2.2, spaceBetween: 10, pagination: false},
                640: {slidesPerView: 3, spaceBetween: 15},
                1024: {slidesPerView: 4, spaceBetween: 20},
                1280: {slidesPerView: 5, spaceBetween: 20},
            },
        }
    },
    methods: {
        getData() {
            this.is_loading = true
            axios.post('/axios/popular/brands')
                .then(({data}) => {
                    this.brands = data
                })
                .finally(() => {
                    this.is_loading = false
                })
        },
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance
        },
        slideNext() {
            this.swiper?.slideNext()
        },
        slidePrev() {
            this.swiper?.slidePrev()
        },
    },
    mounted() {
        this.getData()
    },
    computed: {
        maxSlidesPerView() {
            return Math.max(
                ...Object.values(this.breakpoints).map(bp => bp.slidesPerView)
            )
        },
    },
    setup() {
        return {
            modules: [Navigation, Pagination],
        }
    }
}
</script>

<style scoped lang="scss">
.popular-brands-slider {
    .pagination-base {
        /* стили для буллетов */
        .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            opacity: 0.5;
            transition: opacity .3s;
        }

        .swiper-pagination {
            bottom: 1rem !important;
        }

        .swiper-pagination-bullet-active {
            opacity: 1;
            background-color: #dc2626; /* red-600 */
        }
    }
}
</style>
